import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import leaflet from 'leaflet';

const styles = (theme) => {
    return {
        root: {
            height: 20,
            width: 150,
            textAlign: 'center',
            backgroundColor: theme.palette.primary.main,
            borderColor: theme.palette.primary.mainBorder,
            borderWidth: 1,
            borderStyle: 'solid',
        },
        coordDisplay: {
            display: 'inline-block',
            height: '100%',
            '&$lat': {
                width: '50%',
            },
            '&$lng': {
                width: '50%',
            }
        },
        coordLabel: {
            height: '100%',
            lineHeight: '20px',
            fontSize: 9,
            fontWeight: 400,
            color: theme.palette.primary.displayText,
            '&$lat': {
                marginLeft: 8
            },
            '&$lng': {
                marginRight: 8
            }
        },
        lat: {},
        lng: {},
    };
}

class LatLngControl extends Component {
    constructor(props) {
        super(props);

        const center = this.props.map.getCenter();

        this.state = {
            lat: this._toDMS(center.lat, ['N', 'S']),
            lng: this._toDMS(center.lng, ['E', 'W']),

        };

        this.props.map.on({
            mousemove: this._handleMouseMove,
        });
    }

    componentWillUnmount = () => {
        this.props.map.off({
            mousemove: this._handleMouseMove,
        });
    }

    render = () => {
        const {classes} = this.props;

        return (
            <div className={this.props.className}>
                <Paper className={classes.root}>
                    <div className={classNames(classes.coordDisplay, classes.lat)}>
                        <Typography
                            className={classNames(classes.coordLabel, classes.lat)}
                            align='center'
                            variant='caption'
                        >
                            {this.state.lat}
                        </Typography>
                    </div>
                    <div className={classNames(classes.coordDisplay, classes.lng)}>
                        <Typography
                            className={classNames(classes.coordLabel, classes.lng)}
                            align='center'
                            variant='caption'
                        >
                            {this.state.lng}
                        </Typography>
                    </div>
                </Paper>
            </div>
        );
    }

    _handleMouseMove = (evt) => {
        this.setState({
            lat: this._toDMS(evt.latlng.lat, ['N', 'S']),
            lng: this._toDMS(evt.latlng.lng, ['E', 'W']),
        })
    }

    _toDMS = (value, suffix) => {
        var suf = suffix[0];

        if (value < 0) {
            suf = suffix[1];
            value = value * -1;
        }

        const deg = ~~value;
        value = (value - deg) * 60;
        const min = ~~value;
        value = (value - min) * 60;
        const sec = value.toFixed(2);

        return deg + '\u00b0' + min + "'" + sec + '"' + suf;
    }
}

LatLngControl.propTypes = {
    map: PropTypes.instanceOf(leaflet.Map).isRequired,
}

export default withStyles(styles)(LatLngControl);
